import { contactsType } from '@/utils/enum';
import { removeEmpty } from '@/utils/helpers';
import moment from 'moment';

export const getAllTransformer = (info) => {
	return {
		id: info.employeeId,
		employeeId: info.employeeId,
		code: info.code,
		num: info.num,
		name: info.arabicFullName,
		email: info.contactInfos.find((e) => e.contactInfoType === contactsType.email.value)?.value,
		formDate: info.createdAt,
		startDate: info.workStart,
		result: '',
		sex: info.gender,
		phone: info.contactInfos.find((e) => e.contactInfoType === contactsType.mobile.value)?.value,
		section: info.section,
		role: info.activeJobDescription,
	};
};

export const filteredPayloadTransformer = (info) => {
	let queryString = '';
	const convertArray = (arr, key) => (arr ? arr.map((c) => `${key}=${c}&`).join('') : '');
	console.log(info)
	queryString += convertArray(info.section, 'Sections');
	queryString += convertArray(
		info.job?.map((e) => e.id),
		'RequiredJob',
	);
	queryString += convertArray(
		info.prevJob?.map((e) => e.id),
		'OldJob',
	);
	queryString += convertArray(info.academicDegrees, 'Certificate');
	queryString += convertArray(info.academicSpecifications, 'AcademicQualificationsIds');
	queryString += convertArray(info.military, 'MilitarySituation');

	const payload = {
		// NameOrCode: info.name,
		JobDescriptions: info.position,

		Gender: info.sex,
		IsGraduated: info.academicFinish,
		Languages: JSON.stringify(
			info.language?.map((e) => ({
				level: e.level,
				languageId: e.id,
			})),
		),
		ComputerSkills: JSON.stringify(
			info.computer?.map((e) => ({
				computerSkillId: e.id,
				value: e.level,
			})),
		),
		Skills: JSON.stringify(
			info.expertise?.map((e) => ({
				id: e.id,
				level: e.level,
			})),
		),
		SalaryFrom: info.minSalary,
		SalaryTo: info.maxSalary,
		AgeFrom: info.minAge,
		AgeTo: info.maxAge,
		HasRelatives: info.relative,
		NightShifts: info.nightWork,
		OverTime: info.extraTime,
	};

	if (Number(info.name)) {
		payload.Num = info.name;
	} else {
		payload.Name = info.name;
	}

	const includes = {
		// IncludeContactInfo: true,
		// IncludeAcademicQualifications: Boolean(
		// 	info.academicDegrees || info.academicSpecifications || info.IsGraduated,
		// ),
		// IncludeComputerSkills: Boolean(info.computer),
		// IncludeCourses: Boolean(info.academicDegrees || info.academicSpecifications || info.IsGraduated),
		// IncludeDetails: Boolean(true),
		// IncludeLanguages: Boolean(info.language),
		// IncludeSkills: Boolean(info.expertise),
		// IncludeOldJobs: Boolean(info.prevJob?.length),
	};

	return { params: { ...payload, ...includes }, queryString: queryString };
};

export const getFilteredTransformer = (info) => {
	return {
		id: info.employeeId,
		employeeId: info.employeeId,
		code: info.code,
		num: info.num,
		name: info.arabicFullName,
		sex: info.gender,
		email: info.contactInfos.find((e) => e.contactInfoType === contactsType.email.value)?.value,
		phone: info.contactInfos.find((e) => e.contactInfoType === contactsType.mobile.value)?.value,
		formDate: info.createdAt,
		startDate: info.workStart,
		section: info.section,
		role: info.activeJobDescription,

		job: info.requiredJobs,
		prevJob: info.oldJobs,
		academicDegrees: info.employeeAcademicQualifications,
		academicSpecifications: info.employeeAcademicQualifications,
		language: info.languages,
		computer: info.computerSkills,
		expertise: info.skills,
		salary: info.expectedSalaryFrom + ' - ' + info.expectedSalaryTo,

		age: info.birthDate
			? Math.floor(moment.duration(moment().diff(moment(info.birthDate))).asYears())
			: null,
	};
};

export const getByIdTransformer = (info) => {
	return {
		activePermanentSystem: info.activePermanentSystem,
		employeeId: info.employeeId,
		code: info.code,
		num: info.num,
		jobDescriptionId: info.jobDescriptionId,
		activeRole: info.activeJobDescription,
		workPlaceId: info.workPlaceId,
		status: info.employeeStatus,

		contactsInfo: info.contactInfos.map((e) => ({
			key: e.contactInfoType,
			value: e.value,
		})),
		personal: {
			firstName: info.arabicFirstName,
			lastName: info.arabicLastName,
			nameInEnglish: info.englishFullName,
			fatherName: info.fatherName,
			motherName: info.motherName,
			sex: info.gender,
			nationality: info.nationality,
			birthday: info.birthDate,
			state: info.city,
			birthLocation: info.birthPlace,
			nationalId: info.nationalNumber,
		},
		healthInfo: {
			haveIllness: info.hasIllness,
			haveSurgery: info.hasSurgical,
			haveAllergy: info.hasSensitive,
			smoking: info.smoker,
			haveIllnessDescription: info.illnessDescription,
			haveSurgeryDescription: info.surgicalDescription,
			haveAllergyDescription: info.sensitiveDescription,
		},
		societyStatus: {
			militaryability: info.militarySituation,
			militaryStatus: info.militaryNote,
			marriageability: info.socialStatus,
			childNumber: info.familyMembersCount,
		},

		academic: info.employeeAcademicQualifications.map((e) => ({
			degree: e.certificate,
			gpa: e.average,
			graduated: e.graduate,
			school: e.school,
			specification: {
				id: e.academicQualificationId,
				specialization: e.specialization,
			},
			year: e.year,
		})),
		language: info.languages.map((e) => ({
			language: {
				name: e.languageName,
				id: e.languageId,
			},
			skill: e.level,
		})),
		computer: info.computerSkills.map((e) => ({
			name: {
				name: e.computerSkillName,
				id: e.computerSkillId,
			},
			skill: e.value,
		})),
		expertise: info.skills.map((e) => ({
			name: {
				name: e.skillName,
				id: e.skillsId,
			},
			skill: e.value,
		})),
		courses: info.courses.map((e) => ({
			certificate: e.isCertificated,
			date: e.date,
			duration: e.durationInMonth,
			name: {
				id: e.courseId,
				name: e.courseName,
			},
			organization: e.donor,
			place: e.place,
		})),

		// !!!!!!!!!!!!!!!!!!!!!!
		experience: info.oldJobs.map((e) => ({
			address: e.companyAddress,
			companyName: {
				id: e.companyId,
				name: e.companyName,
			},
			endDate: e.endDate,
			jobName: e.jobName,
			quitRaison: e.reasonOfLeaving,
			salary: e.lastSalary,
			startDate: e.startDate,
		})),
		recommend: info.testators.map((e) => ({
			company: {
				id: e.companyId,
				name: e.companyName,
			},
			job: e.jobDescription,
			name: e.name,
			phone: e.phone,
		})),

		expectedSalaryMin: info.expectedSalaryFrom,
		expectedSalaryMax: info.expectedSalaryTo,
		haveRelativesWork: info.hasRelatives,
		workNight: info.nightShifts,
		extraWorkOnVacations: info.overTime,

		personalNote: info.infoNote,
		academicNote: info.qualificationsNote,
		practicalNote: info.skillsNote,

		expectedJob: info.requiredJobs,

		workLocation: info.workPlaceId,

		section: info.section,

		reasonForExemption: null,
		endDelay: null,
		imagePath: null,
		attachedFiles: [
			{
				employeeId: null,
				name: null,
				type: null,
				filePath: null,
				deletedAt: null,
				isDeleted: true,
				id: null,
				createdAt: null,
				updatedAt: null,
			},
		],
		details: [
			{
				value: null,
				date: null,
				detailTypeId: null,
				employeeId: null,
				deletedAt: null,
				isDeleted: true,
				id: null,
				createdAt: null,
				updatedAt: null,
			},
		],
	};
};

export const addEmployeeTransformer = (info) => {
	// const personaAxios = {
	// 	sectionIds: ['3fa85f64-5717-4562-b3fc-2c963f66afa6'],
	// 	details: ['3fa85f64-5717-4562-b3fc-2c963f66afa6'],
	// 	code: null,
	// 	expectedSalary: 0,
	// 	imagePath: 'string',
	// };

	const {
		personal = {},
		societyStatus = {},
		healthInfo = {},
		contactsInfo = [],
		academic = [],
		language = [],
		computer = [],
		expertise = [],
		courses = [],
		experience = [],
		recommend = [],
		expectedJob,
		...props
	} = info;

	const personaAxios = {
		arabicFirstName: personal.firstName,
		arabicLastName: personal.lastName,
		englishFullName: personal.nameInEnglish,
		fatherName: personal.fatherName,
		motherName: personal.motherName,
		nationalNumber: personal.nationalId,
		gender: personal.sex || 0,
		nationality: personal.nationality,
		city: personal.state,
		birthPlace: personal.birthLocation,
		militaryNote: personal.militaryNote,
	};

	if (personal.birthday !== null) personaAxios.birthDate = personal.birthday;
	if (societyStatus.militaryability !== null)
		personaAxios.militarySituation = societyStatus.militaryability;
	if (societyStatus.militaryStatus !== null) personaAxios.militaryNote = societyStatus.militaryStatus;
	if (societyStatus.marriageability !== null) personaAxios.socialStatus = societyStatus.marriageability;
	if (societyStatus.childNumber !== null) personaAxios.familyMembersCount = societyStatus.childNumber;

	const healthAxios = {
		hasIllness: healthInfo.haveIllness,
		illnessDescription: healthInfo.haveIllnessDescription,
		hasSurgical: healthInfo.haveSurgery,
		surgicalDescription: healthInfo.haveSurgeryDescription,
		hasSensitive: healthInfo.haveAllergy,
		sensitiveDescription: healthInfo.haveAllergyDescription,
		smoker: healthInfo.smoking,
	};

	const contactsAxios = contactsInfo
		.map((e) => ({
			contactInfoType: e.key,
			value: e.value,
		}))
		.filter((e) => !!e.value);

	const academicAxios = academic.map((e) => ({
		certificate: e.degree,
		school: e.school,
		specialization: e.specification?.specialization || e.specification,
		academicQualificationId: e.specification?.id,
		graduate: Boolean(e.graduated),
		year: e.year,
		average: Number(e.gpa),
	}));

	const languageAxios = language.map((e) => ({
		level: e.skill,
		languageId: e.language.id,
		languageName: e.language.name || e.language,
	}));

	const computerAxios = computer.map((e) => ({
		value: e.skill,
		computerSkillId: e.name?.id,
		computerSkillName: e.name.name || e.name,
	}));

	const expertiseAxios = expertise.map((e) => ({
		value: e.skill,
		skillsId: e.name?.id,
		skillName: e.name.name || e.name,
	}));

	const coursesAxios = courses.map((e) => ({
		isCertificated: Boolean(e.certificate),
		date: e.date,
		durationInMonth: Number(e.duration),
		courseName: e.name.name || e.name,
		courseId: e.name?.id,
		donor: e.organization,
		place: e.place,
	}));

	const experienceAxios = experience.map((e) => ({
		companyId: e.companyName?.id,
		companyName: e.companyName.name || e.companyName,
		jobName: e.jobName,
		startDate: e.startDate,
		endDate: e.endDate,
		reasonOfLeaving: e.quitRaison,
		lastSalary: e.salary,
		companyAddress: e.address,
	}));

	const recommendAxios = recommend.map((e) => ({
		companyAddress: '-',
		companyId: e.company?.id,
		companyName: e.company.name || e.company,
		name: e.name,
		jobDescription: e.job,
		phone: e.phone,
	}));

	// todo:back expectedJob To array
	// const expectedJobAxios =  expectedJob.map((e) => ({
	// 			id: e.id,
	// 	  }))
	const expectedJobAxios = expectedJob;

	const hasRelatives = props.haveRelativesWork;
	const nightShifts = props.workNight;
	const overTime = props.extraWorkOnVacations;

	const infoNote = props.personalNote;
	const qualificationsNote = props.academicNote;
	const skillsNote = props.practicalNote;

	const expectedSalaryFrom = props.expectedSalaryMin;
	const expectedSalaryTo = props.expectedSalaryMax;

	const payload = {
		sectionsId: [],

		...personaAxios,
		...healthAxios,
		contactInfo: contactsAxios,
		academicQualifications: academicAxios,
		languages: languageAxios,
		computerSkills: computerAxios,
		skills: expertiseAxios,
		employeeCourses: coursesAxios,
		oldJobs: experienceAxios,
		testators: recommendAxios,
		hasRelatives,
		nightShifts,
		overTime,
		infoNote,
		qualificationsNote,
		skillsNote,
		expectedSalaryFrom,
		expectedSalaryTo,
		requiredJob: expectedJobAxios,
	};

	return { ...removeEmpty(payload), sectionsId: [] };
};
